import { combineReducers } from 'redux'

import list from './list'
import info from './info'

export default combineReducers({ list, info })



// WEBPACK FOOTER //
// ./src/store/reducers/persons/index.js